import { __decorate } from "tslib";
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import lang from '@blade-sxp/portrait-center/lang/index';
import { getNumByName } from '@blade-sxp/portrait-center/utils/index';
import CircularEcharts from '@blade-sxp/portrait-center/components/basic-echarts/circular-echarts.vue';
import { brightGenderModeDougnutOption } from '@blade-sxp/portrait-center/utils/dougnut-config';
import { isEmpty } from 'lodash';
import TimeMixin from '@blade-sxp/portrait-center/components/time-mixin.vue';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
import NoData from '@blade-sxp/portrait-center/pages/components/no-data/index.vue';
import { getFuncVisitorProportion } from '@blade-sxp/portrait-center/utils/common-request';
let default_1 = class default_1 extends mixins(TimeMixin) {
    dates;
    zoneType;
    chartsData = [];
    chartOptions = brightGenderModeDougnutOption();
    isLoading = false;
    isNoData = true;
    get zoneId() {
        return PortraitCenterModule.zoneId;
    }
    onChangeDates() {
        this.fetchData();
    }
    onChangeZoneId() {
        this.fetchData();
    }
    mounted() {
        this.fetchData();
    }
    // HAPPY: '高兴',
    // UNHAPPY: '不高兴',
    // CALM: '平静'
    setDefaultData() {
        this.chartsData = [
            { name: this.$t('HAPPY'), value: 0 },
            { name: this.$t('CALM'), value: 0 },
            { name: this.$t('UNHAPPY'), value: 0 },
        ];
        this.chartOptions.legend.formatter = (name) => {
            return `${name}`;
        };
    }
    fetchData() {
        this.isNoData = true;
        if (this.zoneId === 0) {
            return false;
        }
        this.isLoading = true;
        this.setDefaultData();
        getFuncVisitorProportion({
            businessId: this.zoneId,
            dateStart: this.dates[0],
            dateEnd: this.dates[1],
            zoneType: this.zoneType,
            sourceType: 'VISIT_OFFLINE_COUNT',
            attributeType: 'EXPRESSION',
        })
            .then((res) => {
            this.setData(res, getNumByName);
        })
            .catch((e) => {
            this.$message.error(e.message || `${this.$t('common.serverError')}`);
        })
            .finally(() => {
            this.isLoading = false;
        });
    }
    setData(data, findFunc) {
        if (isEmpty(data)) {
            return;
        }
        this.isNoData = false;
        data.forEach((item) => {
            this.chartsData = [
                { name: this.$t('HAPPY'), value: findFunc(item.data, 'HAPPY') },
                { name: this.$t('CALM'), value: findFunc(item.data, 'CALM') },
                { name: this.$t('UNHAPPY'), value: findFunc(item.data, 'UNHAPPY') },
            ];
        });
        // forEach(this.ageEchartsData, item => { sum += Number(item.value); });
        this.chartOptions.legend.formatter = (name) => {
            // const value = find(this.ageEchartsData, item => item.name === name).value;
            // const percentage = value / sum * 100;
            // return `${name}   ${(Number.isNaN(percentage) ? 0 : percentage).toFixed(2)}%`;
            return `${name}`;
        };
    }
};
__decorate([
    Prop()
], default_1.prototype, "dates", void 0);
__decorate([
    Prop()
], default_1.prototype, "zoneType", void 0);
__decorate([
    Watch('dates')
], default_1.prototype, "onChangeDates", null);
__decorate([
    Watch('zoneId')
], default_1.prototype, "onChangeZoneId", null);
default_1 = __decorate([
    Component({
        name: 'expression',
        components: { CircularEcharts, 'no-data': NoData },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
